import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { baseGrid, siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import ControlsStyles from '@stories/Components/Global/Carousels/Carousel/Controls/Controls.styles';
import DotPaginationStyles from '@stories/Components/Global/DotPagination/DotPagination.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --fgColor: ${brand.global.white};

  position: relative;
  display: grid;
  color: var(--fgColor);
  height: calc(100vh - var(--headerHeight, 0px));
  overflow: hidden;
  overflow: clip;
  grid-template-rows: 1fr 2fr;
`;
const Inner = styled.div `
  ${siteWide};
  ${baseGrid};

  grid-area: 1 / 1;
  height: 100%;
  align-items: end;
  padding-top: 20px;
  padding-bottom: 30px;

  @media ${from(Device.MobileLarge)} {
    align-items: start;
    padding-top: 0;
    padding-bottom: 0;
    grid-row: 2 / span 2;
  }
`;
const PaginationWrapper = styled.div `
  grid-column: 1 / span 1;
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${Container}[data-site='mep'] & {
    gap: 40px;
  }

  ${DotPaginationStyles.Container} {
    transform: translateY(-100%) rotate(90deg);
    transform-origin: bottom left;
    height: ${fluid(40, 60)};
  }

  ${Container}[data-site='ess'] & {
    ${DotPaginationStyles.Container} {
      --colorBg: ${brand.global.red};
      --colorInactive: ${brand.global.red};
      --colorActive: ${brand.global.white};
      --colorBgActive: ${brand.global.white};
    }

    ${DotPaginationStyles.Item}::after {
      ${transition('max-height')};

      display: block;
      content: '';
      background: var(--colorActive);
      height: calc(var(--height) + var(--sitePadding));
      width: var(--width);
      transform: translate(0, 100%);
      max-height: 0;
      position: absolute;
    }

    ${DotPaginationStyles.Item} {
      &[aria-current='true']::after {
        max-height: 100%;
      }
    }
  }

  ${ControlsStyles.Container} {
    display: flex;
    flex-direction: column;
  }

  ${ControlsStyles.Button} {
    transform: rotate(90deg);

    @media ${from(Device.TabletLarge)} {
      --colourBorder: ${brand.global.white};
      --colourText: ${brand.global.white};
    }
  }
`;
const HeroBannerCarouselStyles = {
    Container,
    PaginationWrapper,
    Inner,
};
export default HeroBannerCarouselStyles;
